var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIntersection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    width: "800px",
    height: "800px",
    viewBox: "0 -3 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7,14 C3.13400675,14 0,10.8659932 0,7 C0,3.13400675 3.13400675,0 7,0 C8.07359729,0 9.09074462,0.241691045 10,0.673631164 C10.9092554,0.241691046 11.9264027,0 13,0 C16.8659932,0 20,3.13400675 20,7 C20,10.8659932 16.8659932,14 13,14 C11.9264027,14 10.9092554,13.758309 10,13.3263688 C9.09074462,13.758309 8.07359729,14 7,14 Z M7,2 C4.23857625,2 2,4.23857625 2,7 C2,9.76142375 4.23857625,12 7,12 C7.34275439,12 7.6774536,11.9655117 8.0008167,11.899816 C6.76314869,10.6372065 6,8.90772473 6,7 C6,5.09227527 6.76314869,3.36279347 8.0008167,2.10018397 C7.6774536,2.0344883 7.34275439,2 7,2 Z M14.0008167,7 C14.0008167,8.90772473 13.237668,10.6372065 12,11.899816 C12.3233631,11.9655117 12.6580623,12 13.0008167,12 C15.7622404,12 18.0008167,9.76142375 18.0008167,7 C18.0008167,4.23857625 15.7622404,2 13.0008167,2 C12.6580623,2 12.3233631,2.0344883 12,2.10018397 C13.237668,3.36279347 14.0008167,5.09227527 14.0008167,7 Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntersection);
export default __webpack_public_path__ + "static/media/intersection.7fe07d60.svg";
export { ForwardRef as ReactComponent };